import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Profile from '@/pages/profile/Profile'
import Contacts from '@/pages/Contacts'
import CoursesEntry from '@/pages/CoursesEntry'
import CoursesAdvanced from '@/pages/CoursesAdvanced'
import OnlineEnrollment from '@/pages/OnlineEnrollment'
import SidebarMenuItems from '@/data/ProfileSidebarMenu'
import AboutCourses from '@/pages/AboutCourses'

// lazy load
const AboutLectors = r => require.ensure([], () => r(require('@/pages/AboutLectors')))
// const AboutCourses = r => require.ensure([], () => r(require('@/pages/AboutCourses')))

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  // scrollBehavior (to, from, savedPosition) {
    // setTimeout(() => {
    //   return { x: 0, y: 0 }
    // }, 100)
  // },
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/contacts', name: 'Contacts', component: Contacts },
    { path: '/online-enrollment', name: 'OnlineEnrollment', component: OnlineEnrollment },
    { path: '/about/courses', name: 'AboutCourses', component: AboutCourses },
    { path: '/about/lectors', name: 'AboutLectors', component: AboutLectors },
    { path: '/courses-entry', name: 'CoursesEntry', component: CoursesEntry },
    { path: '/courses-advanced', name: 'CoursesAdvanced', component: CoursesAdvanced },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

if (process.env.NODE_ENV === 'development') {
  router.addRoutes([
    { path: '/login', name: 'Login', component: Login },
    { path: '/profile',
      name: 'Profile',
      component: Profile,
      redirect: '/profile/user',
      meta: {
        requiresAuth: true
      },
      children: SidebarMenuItems
    }
  ])
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js